import React from 'react'
import { Alert } from 'react-bootstrap'
import { Trans } from 'react-i18next'

const ReclamationsExistAlert = ({ complaints }) => {
    if (!complaints || !complaints.length) {
        return null
    }
    return (
        <Alert>
            <Trans
                i18nKey="orderDialog:complaintsExist"
                values={{ feedbackNumber: complaints[0].feedbackNumber }}
                count={complaints.length}
            >
            </Trans>
            {complaints.length > 1
                ? <ul className='mt-2'>{complaints.map(c => <li key={c.id}>{c.feedbackNumber}</li>)}</ul>
                : null}

        </Alert>
    )
}

export default ReclamationsExistAlert